import { render } from "./Waldbrand.vue?vue&type=template&id=484e4c9a&scoped=true"
import script from "./Waldbrand.vue?vue&type=script&lang=js"
export * from "./Waldbrand.vue?vue&type=script&lang=js"

import "./Waldbrand.vue?vue&type=style&index=0&id=484e4c9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484e4c9a"]])

export default __exports__